import { render, staticRenderFns } from "./CheckingWidget.vue?vue&type=template&id=8f956d06&scoped=true&"
import script from "./CheckingWidget.vue?vue&type=script&lang=js&"
export * from "./CheckingWidget.vue?vue&type=script&lang=js&"
import style0 from "./CheckingWidget.vue?vue&type=style&index=0&id=8f956d06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f956d06",
  null
  
)

export default component.exports